import { OrganizationRole } from "gitpod-next-api/gitpod/v1/organization_pb";
import { useMembership } from "./use-membership";
import { useGetOrganizationPolicies } from "@/queries/organization-queries";
import type { PlainOrganizationPolicies } from "@/queries/organization-queries";
import type { PlainMessage } from "node_modules/@bufbuild/protobuf/dist/esm/message";
import type { AccountMembership } from "gitpod-next-api/gitpod/v1/account_pb";

/**
 * Logic function to determine if a user can create projects
 * Exported for testing purposes
 */
export function mayCreateProject(
    membership: PlainMessage<AccountMembership> | undefined,
    policies: PlainOrganizationPolicies | undefined,
): boolean {
    if (!policies) return true;
    if (!membership) return false;

    // Admins can always create projects
    if (membership.userRole === OrganizationRole.ADMIN) {
        return true;
    }

    // For regular members, check organization policies
    return !!policies.membersCreateProjects;
}

/**
 * Hook to determine whether the current user is allowed to create projects based on:
 * - User's membership role (admin = true)
 * - Organization policies for regular members
 */
export const useMayCreateProject = () => {
    const { membership, isPending: isMembershipPending } = useMembership();
    const { data: policies, isPending: isPoliciesPending } = useGetOrganizationPolicies();

    const isPending = isMembershipPending || isPoliciesPending;

    return {
        isPending,
        mayCreateProject: mayCreateProject(membership, policies),
    };
};
